export default "__VITE_ASSET__B_g2Ivg___"